// extracted by mini-css-extract-plugin
export default {"column":"ag3LTOLR"};